export default __webpack_public_path__ + "static/media/homepasta_thumb.ebbcba07.jpg";